import { useState, useEffect, useRef } from 'react';
import { sb } from '../lib/supabase';

/**
 * Profile autocomplete by full name. Calls onChange(id, name) on select and
 * onChange(null, query) while typing (clears the selection).
 */
export default function OwnerSearch({ displayName, onChange, placeholder = 'Search by name…' }) {
  const [query, setQuery] = useState(displayName || '');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [searching, setSearching] = useState(false);
  const debounce = useRef(null);

  useEffect(() => { setQuery(displayName || ''); }, [displayName]);

  function handleInput(e) {
    const q = e.target.value;
    setQuery(q);
    onChange(null, q);
    clearTimeout(debounce.current);
    if (q.length < 1) { setResults([]); setOpen(false); return; }
    debounce.current = setTimeout(async () => {
      setSearching(true);
      const { data } = await sb
        .from('profiles')
        .select('id, full_name, email')
        .ilike('full_name', `%${q}%`)
        .limit(8);
      setResults(data || []);
      setOpen(true);
      setSearching(false);
    }, 220);
  }

  function select(profile) {
    setQuery(profile.full_name);
    setResults([]);
    setOpen(false);
    onChange(profile.id, profile.full_name);
  }

  return (
    <div style={{ position: 'relative' }}>
      <input
        className="form-input"
        value={query}
        onChange={handleInput}
        onFocus={() => results.length > 0 && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 160)}
        placeholder={placeholder}
        autoComplete="off"
      />
      {searching && (
        <span style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 10, color: '#888780' }}>searching…</span>
      )}
      {open && results.length > 0 && (
        <div className="owner-dropdown">
          {results.map((p) => (
            <div key={p.id} className="owner-option" onMouseDown={() => select(p)}>
              <div className="owner-option-name">{p.full_name}</div>
              {p.email && <div className="owner-option-email">{p.email}</div>}
            </div>
          ))}
        </div>
      )}
      {open && !searching && results.length === 0 && query.length > 1 && (
        <div className="owner-dropdown">
          <div style={{ padding: '10px 12px', fontSize: 11, color: '#888780' }}>No users found</div>
        </div>
      )}
    </div>
  );
}
